<div class="dashboard-wrapper py-4 px-3 px-md-4 pb-5">

    <section class="hero-banner p-4 p-md-5 rounded-4 mb-4 text-white position-relative overflow-hidden">
        <div class="position-relative z-2 max-w-xl">
            <span
                class="badge badge-pill badge-secure mb-3 d-inline-flex align-items-center gap-2 px-3 py-2 small font-inter-bold rounded-pill">
                <i class="bi bi-shield-shaded"></i> Secure Verification Process
            </span>
            <h1 class="display-6 fw-bold mb-3 font-inter-bold">Verify Your Trading Partner</h1>
            <p class="opacity-80 mb-4 lh-base font-inter-light">
                Complete our simple 3-step verification process to verify your buyer or seller. This ensures secure and
                trustworthy transactions for all parties involved.
            </p>
            <button
                class="btn btn-action-start d-inline-flex align-items-center gap-2 text-white px-4 py-2.5 rounded-3 fw-semibold transition-all"
                (click)="startVerificationWorkflow()">
                <i class="bi bi-arrow-right small"></i> Start Verification 
            </button>
        </div>
    </section>

    <!-- <section class="row g-4 mb-5">
        <div class="col-6 col-md-3">
            <div class="stat-card bg-white p-4 rounded-4 border shadow-sm d-flex align-items-top gap-2">
                <div
                    class="stat-icon-wrapper rounded-3 bg-blue-tint d-flex align-items-center justify-content-center text-primary">
                    <i class="bi bi-clock-fill fs-5"></i>
                </div>
                <div>
                    <h3 class="card-data fw-bold mb-0 lh-1">{{ stats.pending }}</h3>
                    <p class="card-text mb-2 mt-1 ">Pending Verifications</p>
                </div>
            </div>
        </div>

        <div class="col-6 col-md-3">
            <div class="stat-card bg-white p-4 rounded-4 border shadow-sm d-flex align-items-top gap-2">
                <div
                    class="stat-icon-wrapper rounded-3 bg-orange-tint d-flex align-items-center justify-content-center text-warning">
                    <i class="bi bi-hourglass-split fs-5"></i>
                </div>
                <div>
                    <h3 class="fw-bold card-data mb-0 lh-1">{{ stats.inReview }}</h3>
                    <p class="card-text mb-2 mt-1 ">In Review</p>
                </div>
            </div>
        </div>

        <div class="col-6 col-md-3">
            <div class="stat-card bg-white px-3 py-4 rounded-4 border shadow-sm d-flex align-items-top gap-2">
                <div
                    class="stat-icon-wrapper rounded-3 bg-green-tint d-flex align-items-center justify-content-center text-success">
                    <i class="bi bi-check-circle-fill fs-5"></i>
                </div>
                <div>
                    <h3 class="fw-bold card-data mb-0 lh-1">{{ stats.completed }}</h3>
                    <p class="card-text mb-2 mt-1 ">Completed this Month</p>
                </div>
            </div>
        </div>

        <div class="col-6 col-md-3">
            <div class="stat-card bg-white p-4 rounded-4 border shadow-sm d-flex align-items-top gap-2">
                <div
                    class="stat-icon-wrapper rounded-3 bg-purple-tint d-flex align-items-center justify-content-center text-purple">
                    <i class="bi bi-currency-dollar fs-5"></i>
                </div>
                <div>
                    <h3 class="fw-bold card-data mb-0 lh-1">${{ stats.spend | number }}</h3>
                    <p class="card-text mb-2 mt-1 ">Verification Spend</p>
                </div>
            </div>
        </div>
    </section> -->

    <section class="bg-white border rounded-4 shadow-sm p-4">

        <div class="row g-3 align-items-end justify-content-between">

            <!-- 1. Search Bar -->
            <div class="col-12 col-lg-4">
                <label class="form-label text-header fw-semibold tracking-wide mb-1.5">
                    Search Audit List
                </label>
                <div class="position-relative search-input-group">
                    <i
                        class="bi bi-search search-icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary"></i>
                    <input type="text" class="form-control ps-5 py-2 shadow-none border-light-subtle rounded-3"
                        [ngModel]="pagination$.value.companyName"
                        (input)="onCompanyNameChange($any($event.target).value)"
                        placeholder="Search by company name...">
                </div>
            </div>

            <!-- 2. Filters Group -->
            <div class="col-12 col-lg-7">
                <div class="row g-2 align-items-end">

                    <!-- Country Filter -->
                    <div class="col-12 col-sm-4">
                        <label
                            class="form-label text-header fw-semibold tracking-wide mb-1.5">Country</label>
                        <div class="position-relative">
                            <input type="text" class="form-control filter-dropdown filter"
                                placeholder="Filter by Country" [formControl]="countrySearchControl"
                                [matAutocomplete]="countryAuto">

                            <mat-autocomplete #countryAuto="matAutocomplete"
                                (optionSelected)="onCountryChange($event.option.value)">
                                <mat-option value="" class="fw-semibold text-primary">ALL</mat-option>
                                @for(country of filteredCountries$ | async; track country.name){
                                <mat-option [value]="country.name">
                                    {{ country.name }}
                                </mat-option>
                                }
                            </mat-autocomplete>
                        </div>
                    </div>

                    <!-- Status Filter -->
                    <div class="col-12 col-sm-4">
                        <label
                            class="form-label text-header fw-semibold tracking-wide mb-1.5">Status</label>
                        <select class="form-control filter-dropdown filter"
                            [ngModel]="pagination$.value.status" (ngModelChange)="onStatusChange($event)">
                            <option value="">All Statuses</option>
                            <option value="new">New</option>
                            <option value="processing">Processing</option>
                            <option value="success">Success</option>
                            <option value="failed">Failed</option>
                        </select>
                    </div>

                    <!-- Sort Order -->
                    <div class="col-12 col-sm-4">
                        <label class="form-label text-header fw-semibold tracking-wide mb-1.5">Sort
                            Order</label>
                        <select class="form-control filter-dropdown filter"
                            [ngModel]="pagination$.value.sortOrder" (ngModelChange)="onSortOrderChange($event)">
                            <option value="desc">Latest to Oldest</option>
                            <option value="asc">Oldest to Latest</option>
                        </select>
                    </div>

                </div>
            </div>

            <!-- 3. Reset Button Action -->
            <div class="col-12 col-lg-1 d-flex justify-content-lg-end">
                <button type="button"
                    class="btn btn-light border-light-subtle btn-reset text-secondary rounded-3 d-inline-flex align-items-center justify-content-center w-100 py-2"
                    (click)="resetSearch()" title="Reset Filters">
                    <i class="bi bi-arrow-clockwise fs-5"></i>
                </button>
            </div>

        </div>

    </section>
    <section class="bg-white border rounded-4 shadow-sm overflow-hidden mt-4 mb-5 mb-md-0">

        <header class="p-4">
            <h2 class="table-header mb-1 font-inter-bold fw-bold">Audit History</h2>
            <p class="sub-text small mb-0">Manage and track all seller audit requests</p>
        </header>
        @if (verificationList$ | async; as state){
        @if(state.loading){
         <div class="overlay">
            <div class="spinner-border"></div>
        </div>
        }
        @else if(state.error){
        <div>
            {{state.error}}
        </div>
        }
        @else if (state.data && state.data.length>0){
        <div class="table-responsive d-none d-md-block">
            <table class="table align-middle custom-dashboard-table mb-0">
                <thead>
                    <tr>
                        <th scope="col" class="text-uppercase x-small text-secondary tracking-wider  px-4 py-3">User
                            Name</th>
                        <th scope="col" class="text-uppercase x-small text-secondary tracking-wider py-3">Company</th>
                        <th scope="col" class="text-uppercase x-small text-secondary tracking-wider py-3">Date Submitted
                        </th>
                        <th scope="col" class="text-uppercase x-small text-secondary tracking-wider py-3">Status</th>
                        <th scope="col" class="text-uppercase x-small text-secondary tracking-wider py-3 text-endpe">
                            Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let record of state.data " class="table-row-hover">
                        <td class="py-3">
                            <div class="d-flex align-items-center gap-3">
                                <div
                                    class="avatar-circle rounded-circle bg-light d-flex align-items-center justify-content-center fw-semibold text-secondary overflow-hidden">
                                    {{ record.contactName.charAt(0) }}
                                </div>
                                <div>
                                    <div class="row-header fw-semibold text-wrap">{{ record.contactName }}</div>
                                    <div class="sub-row x-small mt-0.5">ID: #{{ record.id}}</div>
                                </div>
                            </div>
                        </td>

                        <td class="py-3">
                            <div class="text-dark row-header row-other">{{ record.companyName }}</div>
                            <div class="sub-row x-small mt-0.5">{{ record.country }}</div>
                        </td>

                        <td class="py-3">
                            <div class="text-dark row-header row-other">{{ record.dateCreated | date:'mediumDate'}}
                            </div>
                            <div class="sub-row  x-small mt-0.5">{{ record.daysAgo }}</div>
                        </td>

                        <td class="py-3">
                            <select [ngModel]="record.status" (ngModelChange)="onStatusUpdate(record, $event)"
                                class="form-select form-select-sm badge-status rounded-pill px-3 py-1.5 fw-semibold border-0"
                                [class.status-success]="record.status === 'SUCCESS'"
                                [class.status-failed]="record.status === 'FAILED'"
                                [class.status-new]="record.status === 'NEW'"
                                [class.status-processing]="record.status === 'PROCESSING'"
                                style="width: 140px; cursor: pointer; font-size: 0.75rem;">

                                <option value="NEW" class="bg-white text-dark">+ New</option>
                                <option value="PROCESSING" class="bg-white text-dark">⏳ Processing</option>
                                <option disabled value="SUCCESS" class="bg-light text-dark">✅ Success</option>
                                <option value="FAILED" class="bg-light text-dark">❌ Failed</option>
                            </select>
                        </td>

                        <td class="py-3 ">
                            <div class="d-flex align-items-center justify-content-start gap-3">
                                <button (click)="mapCofanetForm(record)"
                                    class="btn btn-view-report btn-sm rounded-2 text-primary fw-semibold d-inline-flex align-items-center gap-1">
                                    Map Canon Request
                                </button>
                                <!-- <button class="btn btn-icon-download p-1 border-0 bg-transparent text-secondary"
                                    (click)="downloadReport(record.id)">
                                    <i class="bi bi-download"></i>
                                </button> -->
                                <button
                                    class="btn btn-view-report btn-sm rounded-2 text-primary fw-semibold d-inline-flex align-items-center gap-1"
                                    (click)="addCanonRecord(record)">
                                    Add Canon Record
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Mobile view: cards layout -->
        <div class="d-block d-md-none mobile-cards-container">
            <div *ngFor="let record of state.data" class="mobile-card p-3 border-bottom position-relative">
                <!-- Top Row: Avatar and Seller Name + ID -->
                <div class="d-flex align-items-center gap-3 mb-3">
                    <div
                        class="avatar-circle rounded-circle bg-light d-flex align-items-center justify-content-center fw-semibold text-secondary overflow-hidden">
                        {{ record.contactName.charAt(0).toUpperCase() }}
                    </div>
                    <div>
                        <div class="fw-bold row-header text-dark font-inter-bold" style="font-size: 1.05rem;">
                            {{ record.contactName }}
                        </div>
                        <div class="sub-row x-small text-muted mt-0.5">ID: #{{ record.id }}</div>
                    </div>
                </div>

                <!-- Info Grid -->
                <div class="card-info-grid mb-3">
                    <div class="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                        <span class="text-muted small">Company</span>
                        <span class="fw-semibold text-dark text-end small">{{ record.companyName }}, {{ record.country
                            }}</span>
                    </div>

                    <div class="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                        <span class="text-muted small">Date Submitted</span>
                        <span class="fw-semibold text-dark text-end small">{{ record.dateCreated | date:'mediumDate'
                            }}</span>
                    </div>

                    <div class="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                        <span class="text-muted small">Status</span>
                        <select [ngModel]="record.status" (ngModelChange)="onStatusUpdate(record, $event)"
                            class="form-select form-select-sm badge-status rounded-pill px-3 py-1.5 fw-semibold border-0 text-center"
                            [class.status-success]="record.status === 'SUCCESS'"
                            [class.status-failed]="record.status === 'FAILED'"
                            [class.status-new]="record.status === 'NEW'"
                            [class.status-processing]="record.status === 'PROCESSING'"
                            style="width: 140px; cursor: pointer; font-size: 0.75rem;">

                            <option value="NEW" class="bg-white text-dark">+ New</option>
                            <option value="PROCESSING" class="bg-white text-dark">⏳ Processing</option>
                            <option disabled value="SUCCESS" class="bg-light text-dark">✅ Success</option>
                            <option value="FAILED" class="bg-light text-dark">❌ Failed</option>
                        </select>
                    </div>
                </div>

                <!-- Actions Row -->
                <div class="d-flex align-items-center justify-content-between mt-3">
                    <button (click)="mapCofanetForm(record)"
                        class="btn btn-view-report btn-sm rounded-2 text-primary fw-semibold d-inline-flex align-items-center gap-1">
                        Map Canon Request
                    </button>
                    <div class="d-flex gap-3">
                        <button class="btn btn-icon-download p-1 border-0 bg-transparent text-secondary"
                            (click)="downloadReport(record.id)">
                            <i class="bi bi-download"></i>
                        </button>
                        <button class="btn btn-icon-download p-1 border-0 bg-transparent text-secondary"
                            data-bs-toggle="tooltip" data-bs-placement="top" title="Add Canon Record"
                            (click)="addCanonRecord(record)">
                            <i class="bi bi-plus"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <footer class="d-flex flex-column flex-md-row align-items-center justify-content-between p-4 mt-2 pb-5">
            <div class="text-muted small mb-3 mb-md-0">
                Showing <span class="fw-semibold text-dark">{{start}}</span> to <span
                    class="fw-semibold text-dark">{{end}}</span> of <span class="fw-semibold text-dark">{{totalRecord}}
                    results</span>

            </div>
            <nav aria-label="Page navigation dashboard items">
                <ul class="pagination pagination-sm mb-0 gap-2">

                    <li class="page-item" [class.disabled]="currentPage === 0">
                        <button class="page-link rounded-2 border px-3" (click)="onPageChange((+currentPage) - 1)">
                            Previous
                        </button>
                    </li>

                    @for(pageNum of pages; track pageNum){
                    <li class="page-item" [class.active]="currentPage === pageNum">
                        <button class="page-link rounded-2 border" (click)="onPageChange(pageNum)">
                            {{ pageNum + 1 }}
                        </button>
                    </li>
                    }

                    <li class="page-item" [class.disabled]="currentPage === (totalPages - 1)">
                        <button class="page-link rounded-2 border px-3" (click)="onPageChange((+currentPage) + 1)">
                            Next
                        </button>
                    </li>

                </ul>
            </nav>
        </footer>
        }
        }
    </section>
</div>